import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PublicNavbar() {
  const { user, isAuthenticated, logout, isClient } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [isInIframe, setIsInIframe] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    
    // Detectar si estamos en un iframe
    setIsInIframe(window.self !== window.top);
    
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  // Función para manejar el clic en "Inicio"
  const handleInicio = () => {
    // Si es usuario CIP y está en iframe, ir al establecimiento 9
    if (user?.origen === 'cip' && isInIframe) {
      navigate("/establecimientos/9");
    } else {
      // Usuario normal, ir a la lista de establecimientos
      navigate("/");
    }
  };

  return (
    <header
      className={`
        fixed top-0 inset-x-0 z-30
        transition-colors duration-300
        ${scrolled ? "bg-white/95 shadow-md backdrop-blur" : "bg-transparent"}
      `}
    >
      {/* franja de degradado SOLO cuando no hay scroll */}
      {!scrolled && (
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-transparent" />
      )}

      <nav className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* logo */}
        <button
          onClick={handleInicio}
          className={`flex items-center gap-2 font-bold text-lg cursor-pointer ${
            scrolled ? "text-emerald-700" : "text-white"
          }`}
        >
          <span className="text-2xl">⚽</span>
          <span className="hidden sm:inline">Canchas Perú</span>
        </button>

        {/* acciones */}
        <div className="flex items-center gap-3">
          {isAuthenticated ? (
            <>
              <span
                className={`${
                  scrolled ? "text-slate-700" : "text-white/90"
                } hidden md:inline`}
              >
                {user?.name || user?.nombre || user?.email}
              </span>
              {(isClient() || user?.role === "establecimiento" || user?.role === "administrador") && location.pathname !== "/dashboard" && (
                <button
                  onClick={() => navigate("/dashboard")}
                  className={`rounded-full px-4 py-2 text-sm font-semibold transition
                    ${
                      scrolled
                        ? "bg-emerald-600 text-white hover:bg-emerald-700"
                        : "bg-white/95 text-emerald-700 hover:bg-white"
                    }`}
                >
                  Mi Dashboard
                </button>
              )}
              {(isClient() || user?.role === "establecimiento" || user?.role === "administrador") && location.pathname === "/dashboard" && (
                <button
                  onClick={handleInicio}
                  className={`rounded-full px-4 py-2 text-sm font-semibold transition
                    ${
                      scrolled
                        ? "bg-blue-600 text-white hover:bg-blue-700"
                        : "bg-white/95 text-blue-700 hover:bg-white"
                    }`}
                >
                  Inicio
                </button>
              )}
              <button
                onClick={handleLogout}
                className={`rounded-full px-4 py-2 text-sm font-semibold transition
                  ${
                    scrolled
                      ? "bg-red-600 text-white hover:bg-red-700"
                      : "bg-red-600/90 text-white hover:bg-red-600"
                  }`}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className={`rounded-full px-4 py-2 text-sm font-semibold transition
                  ${
                    scrolled
                      ? "bg-emerald-600 text-white hover:bg-emerald-700"
                      : "bg-white/95 text-emerald-700 hover:bg-white"
                  }`}
              >
                Ingresar
              </Link>
              <Link
                to="/register"
                className={`rounded-full px-4 py-2 text-sm font-semibold transition
                  ${
                    scrolled
                      ? "bg-blue-600 text-white hover:bg-blue-700"
                      : "bg-white/95 text-blue-700 hover:bg-white"
                  }`}
              >
                Registrarse
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}